import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';
import ManageGroups from 'src/components/Elements/ManageGroups';

const GroupManagementModal = () => (
  <ModalBase
    name={MODALS.manageGroups}
    size={MODALS_SIZE.small}
    form={FORM.get_groups}>
    <ManageGroups />
  </ModalBase>
);

export default GroupManagementModal;
